import type { WorkType } from "@/mocks/works";

export const workTypeLabel = (type: WorkType): string => (type === "movie" ? "电影" : "电视剧");

export const formatCnDate = (date: string): string => {
  const parts = date.split("-");
  if (parts.length !== 3) return date;
  return `${parts[0]} 年 ${Number(parts[1])} 月 ${Number(parts[2])} 日`;
};

export const shareUrl = (): string => window.location.href;